import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Link, Redirect } from 'react-router-dom';
import { Location } from 'history';

import { User } from "_types/system";
import { RootState } from '_store';
import { beginSession } from '_store/system/thunks';
import { useRequest, errorMessage, makeRequest } from '_utils/request';
import { WEBSITE_URL } from '_utils/config';

import { Loader, SessionPane } from '_components'

import './Login.sass'

type LoginError = "invalidCredentials";

const loginErrorMessages = new Map<LoginError, string>([
  ["invalidCredentials", "Please check your credentials and try again."]
]);

const connector = connect(
  (state: RootState) => ({ user: state.system.user }),
  ({ beginSession })
);

// TODO extract
interface LocationState {
  emailTypedInSoFar?: string;
  from?: string;
}

type LoginProps = ConnectedProps<typeof connector> & { location: Location<LocationState>; }

const PLogin: React.FC<LoginProps> = ({ location, user, beginSession }) => {
  const [email, setEmail] = useState<string>((location && location.state && location.state.emailTypedInSoFar) || '');
  const [password, setPassword] = useState<string>('');
  const [keepSignedIn, setKeepSignedIn] = useState<boolean>(false);

  const [result, fetchResult] = useRequest<User, LoginError>(
    undefined,
    response => response.status === 401 ? "invalidCredentials" : null
  );

  useEffect(() => {
    if (result.kind === "success") {
      beginSession(result.payload, keepSignedIn);
    }
  });

  if (user != null) {
    const redirect = (location && location.state && location.state.from) || '/';
    return <Redirect to={redirect} />
  }

  const busy = result.kind === 'requested' || result.kind === 'loading';
  
  return (
    <SessionPane className="login-form">
      <img className="login-form-logo" alt="Sol logo" src="/logo_sol_small.svg" />
      <form onSubmit={e => {
        e.preventDefault();
        fetchResult(makeRequest('/login', 'POST', {email, password}));
      }}>
        <div className="form-group">
          <input className="form-control" value={email} name="email"
            onChange={e => setEmail(e.target.value)} type="text" placeholder="e-mail address" />
        </div>
        <div className="form-group">
          <input className="form-control" value={password} name="password"
            onChange={e => setPassword(e.target.value)} type="password" placeholder="password" />
          <p><small><Link to={{
            pathname: "/reset-password",
            state: {
              emailTypedInSoFar: email,
              from: (location && location.state && location.state.from) || '/',
            },
          }}>
            Forgotten password?
          </Link></small></p>
        </div>
        <div className="form-group">
          <div className="form-check">
            <input className="form-check-input" checked={keepSignedIn} name="keepSignedIn"
              onChange={e => setKeepSignedIn(e.target.checked)} type="checkbox" id="keepSignedInCheckbox" />
            <label className="form-check-label" htmlFor="keepSignedInCheckbox">
              Keep me signed in
            </label>
          </div>
        </div>

        {result.kind === "error" && <p style={{color: 'red'}}>{errorMessage(result.error, loginErrorMessages)}</p>}

        {busy
          ? <Loader />
          : <button className="btn btn-primary" type="submit" disabled={busy}>Continue</button>
        }

        <p><small>
          Don't have an account? &ensp;
          <a href={WEBSITE_URL}>
            Request a free sample
          </a>
        </small></p>
      </form>
    </SessionPane>
  );
}

export const Login = connector(PLogin);
